<template>
  <div>
    <childQOweb
      class="hidden-sm-and-down"
      :updateShopingQuantity="updateShopingQuantity"
      :snackbar="sendSnack"
      :products="orderItems"
      :actualizarContadores="actualizarContadores"
      :session="session"
      :totalArt="totalArt"
      :deleteAll="deleteAll"
      :key="articlesQuantity"
    ></childQOweb>

    <childQOmovil
      class="hidden-md-and-up"
      :updateShopingQuantity="updateShopingQuantity"
      :snackbar="sendSnack"
      :products="orderItems"
      :actualizarContadores="actualizarContadores"
      :session="session"
      :totalArt="totalArt"
      :deleteAll="deleteAll"
      :key="articlesQuantity2"
    ></childQOmovil>
  </div>
</template>

<script>
import _ from "underscore";
import childQOweb from "./quickorderWeb_child.vue";
import childQOmovil from "./quickorderMovil_child.vue";

export default {
  components: {
    childQOweb,
    childQOmovil,
  },

  data() {
    return {
      session: true,
      cartQuantity: 0,
      pieceQuantity: 0,
      orderItems: [],
      orderItemsSm: [],
    };
  },

  props: {
    updateShopingQuantity: Function,
    sendSnack: Function,
  },

  methods: {
    actualizarContadores: function () {
      this.orderItems = JSON.parse(localStorage.getItem("shoppingCart"));
      this.orderItemsSm = this.orderItems.map((item) => {
        var orderItem = {
          description: item.description,
          code: item.code,
          characteristics: item.characteristics,
          quantity: item.quantity,
        };
        return orderItem;
      });
      this.cartQuantity = this.orderItems.length;
      this.pieceQuantity = this.orderItems.reduce(function (
        previousValue,
        currentValue
      ) {
        return Number(previousValue) + Number(currentValue.quantity);
      },
      0);
    },

    deleteAll: function () {
      localStorage.setItem("shoppingCart", "[]");
      this.actualizarContadores();
    },
  },

  computed: {
    articlesQuantity() {
      return this.cartQuantity;
    },
    articlesQuantity2() {
      return this.cartQuantity + 1;
    },
    totalArt() {
      return this.pieceQuantity;
    },
  },

  watch: {},

  created: function () {
    document.title = "Risoul - Lista Rápida";
    this.orderItems = _.sortBy(
      JSON.parse(localStorage.getItem("shoppingCart")),
      "description"
    );

    this.orderItemsSm = this.orderItems.map((item) => {
      var orderItem = {
        description: item.description,
        code: item.code,
        characteristics: item.characteristics,
        quantity: item.quantity,
      };
      return orderItem;
    });
  },

  mounted() {},
};
</script>

<style lang="scss" scoped>
@media (min-width: 960px) {
  .quickOrder-container {
    max-width: 980px;
  }
}

@media (min-width: 1264px) {
  .quickOrder-container {
    max-width: 1129px;
  }
}

@media (min-width: 1879px) {
  .quickOrder-container {
    max-width: 1691px;
  }
}

@media (min-width: 1904px) {
  .quickOrder-container {
    max-width: 1556px;
    margin: auto;
  }
}
</style>
